import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

function Button({
  message,
  onClick,
  disabled,
  style = {},
  buttonClasses = '',
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        buttonClasses,
        'border-none',
        'box-shadow-none',
        'border-radius-level-1',
        'text-size-secondary',
        'margin-right-sm',
        'text-weight-500',
        'padding-horizontal-xs',
        'padding-vertical-xxs',
        'transition-normal',
        {
          'background-grey-10': !disabled,
          'color-white': !disabled,
          'background-blue-6-hover': !disabled,
          'cursor-pointer': !disabled,
        },
        {
          'background-grey-7': disabled,
          'color-white': disabled,
          'cursor-disabled': disabled,
        },
      )}
      style={style}
      disabled={disabled}
    >
      <FormattedMessage {...message} />
    </button>
  );
}

Button.propTypes = {
  message: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  buttonClasses: PropTypes.string,
  style: PropTypes.object,
};

export default Button;
